import React, { useContext } from "react";
import { useState } from "react";
import { useEffect,useMemo } from "react";
import "./BuyEvaluationComp.css";
import BuyBtn from "../../MiniComponents/BuyBtn/BuyBtn";
import { getData } from "../../../services/NodeServices";
import bg from "../../../assets/images/bg.webp";
import { Img } from "react-image";
import { useNavigate } from "react-router-dom";

export default function BuyEvaluationComp() {
  const [value, setValue] = useState(10000);
  const [selectedKey, setSelectedKey] = useState(7);
  
  const navigate = useNavigate()
 

  const[type,setType]=useState('Standard Challenge')
  const [selectedid,setselectedid]=useState(1)
  const [selectedPlan,setselectedPlan]=useState(false)
  const [allplan,setPlans]=useState([])
  const getPlan=async()=>{
    try{
      const result = await getData('api/plans/getplans')
    if(result.status){
      setPlans(result.data)
      setselectedPlan(result.data[0])
    }
  
    }catch{
  
    }
   }
  
   useEffect(()=>{
  getPlan()
   },[])



  const setProfitValue=(index)=>{
    let plan = selectedPlan
    
    const val = plan.profittarget.split(',')
    if(val[index]=='-'){
      return '-'
    }
    let strvalue =  (selectedPlan.value * val[index]/100).toFixed(0) || '0.00';
    
    let returnv = `$ ${strvalue}`

    return returnv

  }

  const setDailyLossValue=(index)=>{
    let plan = selectedPlan
    
    const val = plan.dailylosslimit.split(',')
    console.log(index)
    if(val[index]=='-'){
      return '-'
    }
    let strvalue =  (selectedPlan.value * val[index]/100).toFixed(0) || '0.00';
    
    let returnv = `$ ${strvalue}`

    return returnv

  }

  const setMaxLossValue=(index)=>{
    let plan = selectedPlan
    
    const val = plan.maxlosslimit.split(',')
    if(val[index]=='-'){
      return '-'
    }
    let strvalue =  (selectedPlan.value * val[index]/100).toFixed(0) || '0.00';
    
    let returnv = `$ ${strvalue}`

    return returnv

  }



  
  const toggleEvaluation = () => {
    if (type == 'One Step Challenge') {
      setType("Standard Challenge");
      setselectedid(1)
      setselectedPlan(allplan[0])
     
    } else {
      setType("One Step Challenge");
      setselectedid(6)
      setselectedPlan(allplan[5])
    }
  };
  const calculateValue = (percentage,val) => {
    return val ? (val * percentage).toFixed(2) : '0.00';
  };
  const r3Headings = [
    { title: "Trading Period" },
    { title: "Minimum Trading Days" },
    { title: "Profit Target" },
    { title: "Maximum Daily Loss" },
    { title: "Maximum Overall Loss" },
    { title: "Drawdown Type" },
    { title: "Refundable Fee" },
  ];

  const step1Standard = [
    { Title: 'Unlimited', Value: 'Unlimited' },
    { Title: 3, Value: 3 },
    { Title: `$${calculateValue(0.08,allplan[selectedid]?allplan[selectedid].profittarget:'')} (8%)`, Value: calculateValue(0.08,allplan[selectedid]?allplan[selectedid].maxlosslimit:'') },
    { Title: `$${calculateValue(0.05,allplan[selectedid]?allplan[selectedid].maxlosslimit:'')} (5%)`, Value: calculateValue(0.05,allplan[selectedid]?allplan[selectedid].maxlosslimit:'') },
    { Title: `$${calculateValue(0.08,allplan[selectedid]?allplan[selectedid].maxlosslimit:'')} (8%)`, Value: calculateValue(0.08,allplan[selectedid]?allplan[selectedid].maxlosslimit:'') },
    { Title: 'Drawdown Type', Value: 'Drawdown Type' },
    { Title: '-', Value: '-' }
  ];
  const step2Standard= [
    {'Title':'Unlimited','Value':'Unlimited'},
    {'Title':3,'Value':3},
    { Title: `$${calculateValue(0.05)} (5%)`, Value: calculateValue(0.05) },
    { Title: `$${calculateValue(0.05)} (5%)`, Value: calculateValue(0.05) },
    { Title: `$${calculateValue(0.08)} (8%)`, Value: calculateValue(0.08) },
    {'Title':'Drawdown Type','Value':'Drawdown Type'},
    {'Title':'-','Value':'-'}
  ]

  const step3Standard= [
    {'Title':'Unlimited','Value':'Unlimited'},
    {'Title':1,'Value':1},
    {'Title':'None','Value':0},
    {'Title':`$${value*.05}(5%)`,'Value':`$${value*.05}(5%)`},
    {'Title':`$${value*.08}(8%)`,'Value':`$${value*.08}(8%)`},
    {'Title':'Drawdown Type','Value':'Drawdown Type'},
    {'Title':'-','Value':'-'}
  ]

 const handleClickNav=async()=>{
    let user = localStorage.getItem('user')
    if(user){
      navigate('/plans',{state:{autoselect:true,autoplanType:type,autoPlanId:selectedid}} )
    }else{
   navigate('/signin?redirect=/plans')
    }

    
 }
  console.log(allplan[selectedid])

  const handleSelected=(itm)=>{
    setselectedid(itm.plansid)
     setselectedPlan(itm)
  }

  return (
    <div className="buyevaluation__container" sty>
       <Img
          src={bg}
          style={{
            position: "absolute",
            display: "block",
            margin: "0 auto", // centers the image horizontally
            paddingTop: "-181px", // small padding at the top
            width: "100%", // image width relative to the parent
            maxWidth: "100%", // prevents overflow from parent
            height: "auto", // maintains aspect ratio
            zIndex: 1,
            
            pointerEvents: "none",
          }}
          alt="bg"
        />
      <div className="buyevaluation__r1">
        <div className="buyevaluation__r1__p">
          <p>Our Challenges</p>
          <p>
            We are one of the few prop firms that provide real capital through
            live account challenges. Pass our evaluation and trade with actual
            funds, proving your trading skills in a real-world environment.
          </p>
        </div>
        <div className="buyevaluation__r1__buttons">
          <div
            className="buyevaluation__r1b__button1"
            onClick={() => {
              toggleEvaluation(1);
            }}
            style={{
              border:
                type == "Standard Challenge"
                  ? `1px solid var(--accent-color)`
                  :"" ,
            }}
          >
            {type == "Standard Challenge" ? (
              <i class="far fa-dot-circle firstdotcircle dnone"></i>
            ) : (
              <i class="far fa-circle firstcircle"></i>
            )}{" "}
            <p>Standard Challange</p>
          </div>
          <div className="buyevaluation__r1b__button2">
            <div
              className="buyevaluation__r1b__button1"
              onClick={() => {
                toggleEvaluation();
              }}
              style={{
                border:
                  type == "One Step Challenge"
                    ? `1px solid var(--accent-color)`
                    :"" ,
              }}
            >
              {type != "Standard Challenge" ? (
                <i class="far fa-dot-circle firstdotcircle dnone"></i>
              ) : (
                <i class="far fa-circle firstcircle"></i>
              )}{" "}
              <p>One Step Challange</p>
            </div>
          </div>
        </div>
      </div>
      <div className="buyevaluation__r2">
        <p>Select Balance</p>
        <div className="buyevaluation__r2__btn__btnlist">
{allplan
  .filter(itm => itm.type === type) // Show only items matching the type state
  .map((itm) => (
    <div key={itm.id || itm.value}  onClick={()=>{handleSelected(itm)}} style={{width:"100%"}}> {/* Ensure a unique key */}
     
     <div
                    className="buyevaluation__r2__btn"
                    style={{
                      border:
                        itm.plansid == selectedid
                          ? `1px solid var(--accent-color)`
                          : "1px solid #1e1e1e",
                    }}
                   
                  >
                    <p>&#36; {itm.value} </p>
                  </div>
    </div>
  ))
}
        </div>
      </div>

  //    <div className="buyevolution__r3">
        <div className="buyevolution__r3__headings">
          {r3Headings.map((item,index) => {
            return (
              <div key={index} className="buyevolution__r3__headings__item">
                <i class="fas fa-chevron-circle-right"></i> <p>{item.title}</p>
              </div>
            );
          })}
        </div>
     
        <div className="buyevolution__r3__step">
          <div className="buyevolution__r3__step__heading">
            <p>STEP 1</p>
            <div className="buyevolution__r3__step__heading2">
            <p>Challange</p>
            <i class="fas fa-exclamation-circle"></i> 
            </div>
          </div>

          <div className="buyevolution__r3__step__data">

{/* 
          {step1Standard.map((item) => {
            return (
              <div className="buyevolution__r3__step__item">
                 <p>{item.Title}</p>
              </div>
            );
          })} */}
              <div className="buyevolution__r3__step__item">
                 <p>Unlimited</p>
              </div>

              <div className="buyevolution__r3__step__item">
                 <p>3</p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p> {/* { calculateValue(0.05,selectedPlan.profittarget)} (5%) */} {selectedPlan&&setProfitValue(0)} </p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p> {/* { calculateValue(0.05,selectedPlan.dailylosslimit)} (5%) */} {selectedPlan&&setDailyLossValue(0)} </p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p>{/*  { calculateValue(0.05,selectedPlan.maxlosslimit)} (8%)  */} {selectedPlan&&setMaxLossValue(0)}</p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p>balance </p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p>$ {selectedPlan&&selectedPlan.refundfees}</p>
              </div>
          </div>
        </div>

        <div className="buyevolution__r3__step transmode" >
       { selectedPlan&&selectedPlan.type=="Standard Challenge"? 
       
       <> <div className="buyevolution__r3__step__heading">
         <p>STEP 2</p> 
         <div className="buyevolution__r3__step__heading2">
           <p>Verification</p>
           <i class="fas fa-exclamation-circle"></i> 
           </div>
         </div></>:<></>
}

          <div className="buyevolution__r3__step__data">


        {/*   {step2Standard.map((item) => {
            return (
              <div className="buyevolution__r3__step__item">
                 <p>{item.Title}</p>
              </div>
            );
          })} */}
                {selectedPlan&&selectedPlan.type=="Standard Challenge"?<><div className="buyevolution__r3__step__item">
                 <p>Unlimited</p>
              </div>

              <div className="buyevolution__r3__step__item">
                 <p>{selectedPlan.type=="Standard Challenge"?3:'-'}</p>
              </div>
              {selectedPlan&& selectedPlan.type=="Standard Challenge"?   <> <div className="buyevolution__r3__step__item">
                 <p> {/* { calculateValue(0.05,selectedPlan.profittarget)} (5%) */} {selectedPlan&&setProfitValue(1)} </p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p> {/* { calculateValue(0.05,selectedPlan.dailylosslimit)} (5%) */} {selectedPlan&&setDailyLossValue(1)} </p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p>{/*  { calculateValue(0.05,selectedPlan.maxlosslimit)} (8%)  */} {selectedPlan&&setMaxLossValue(1)}</p>
              </div></>:<></>

              }
              <div className="buyevolution__r3__step__item">
                 <p>balance </p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p>-</p>
              </div></>:<></>}

          </div>
        </div>

        <div className="buyevolution__r3__step">
          <div className="buyevolution__r3__step__heading">
            <p>STEP {selectedPlan.type=="Standard Challenge"?3:2}</p>
            <div className="buyevolution__r3__step__heading2">
            <p>Funded</p>
            <i class="fas fa-exclamation-circle"></i> 
            </div>
          </div>

          <div className="buyevolution__r3__step__data">


      {/*     {step3Standard.map((item) => {
            return (
              <div className="buyevolution__r3__step__item">
                 <p>{item.Title}</p>
              </div>
            );
          })} */}
               <div className="buyevolution__r3__step__item">
                 <p>Unlimited</p>
              </div>

              <div className="buyevolution__r3__step__item">
                 <p>{/* {selectedPlan.type=="Standard Challenge"?'-':'-'} */}-</p>
              </div>
             {selectedPlan.type=='Standard Challenge'?<> <div className="buyevolution__r3__step__item">
                 <p> {/* { calculateValue(0.05,selectedPlan.profittarget)} (5%) */}{selectedPlan&&setProfitValue(2)}</p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p> {/* { calculateValue(0.05,selectedPlan.dailylosslimit)} (5%) */} {selectedPlan&&setDailyLossValue(2)} </p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p>{/*  { calculateValue(0.05,selectedPlan.maxlosslimit)} (8%)  */} {selectedPlan&&setMaxLossValue(2)}</p>
              </div></>:<> <div className="buyevolution__r3__step__item">
                 <p> {/* { calculateValue(0.05,selectedPlan.profittarget)} (5%) */}{selectedPlan&&setProfitValue(1)}</p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p> {/* { calculateValue(0.05,selectedPlan.dailylosslimit)} (5%) */} {selectedPlan&&setDailyLossValue(1)} </p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p>{/*  { calculateValue(0.05,selectedPlan.maxlosslimit)} (8%)  */} {selectedPlan&&setMaxLossValue(1)}</p>
              </div></>

             }
              <div className="buyevolution__r3__step__item">
                 <p>balance </p>
              </div>
              <div className="buyevolution__r3__step__item">
                 <p>Refundable</p>
              </div>

          </div>
        </div>
      </div>

      <div className="buyevolution__r4">
        <div style={{width:'fit-content'}} onClick={()=>{handleClickNav()}}>
        <BuyBtn/>
        </div>
      </div>
    </div>
  );
}
